"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.delete.confirm.title': 'Elimina Settore',
    'branch.delete.confirm.message': 'Sei sicuro di voler eliminare questo settore?',
};
